import React, { SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setTerms } from '../../actions/consentActions';
import CheckBox from '../../components/CheckBox';
import ErrorResponse from '../../components/ErrorResponse';
import PrimaryButton from '../../components/PrimaryButton';
import ViewWrapper, { FormWrapper, Header1 } from '../../components/ViewWrapper';
import { linkToTermsOfUse } from '../../constants';
import logo from '../../img/Airthings_Favicon.png';
import { Store } from '../../reducers';
import { RequestType } from '../../reducers/requestReducer';
import styles from './SsoTermsView.module.scss';

const SsoTermsView = (): JSX.Element => {
    const { t: txt } = useTranslation();
    const dispatch = useDispatch();
    const { loading, error } = useSelector((state: Store) => state.requests[RequestType.SetTermsAndConditions]);

    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [validate, setValidate] = useState(false);
    const onChangeAgreeTerms = (): void => {
        setAgreedToTerms(!agreedToTerms);
    };
    const onSubmit = (e: SyntheticEvent<HTMLElement>): void => {
        e.preventDefault();
        if (agreedToTerms) {
            dispatch(setTerms());
        } else {
            setValidate(true);
        }
    };

    return (
        <ViewWrapper>
            <FormWrapper onSubmit={onSubmit} testAttr={'consent-view'}>
                <img src={logo} className={styles.logo} alt={txt('Logo.AirthingsLogo')} />
                <Header1>{txt('SingleSignOn.TermsAndConditionsHeader')}</Header1>
                <CheckBox
                    label="Register.AgreeToTerms"
                    id="agreeToTerms"
                    checked={agreedToTerms}
                    onChange={onChangeAgreeTerms}
                    link={linkToTermsOfUse}
                    linkText="Register.AgreeToTermsLinkText"
                    invalid={validate && !agreedToTerms}
                    helpText="SingleSignOn.AgreeToTermsHint"
                    testAttr="agree-terms"
                />
                {error && <ErrorResponse error={`ErrorCodes.${error.error}`} testAttr={'set-consent-error'} />}
                <PrimaryButton
                    onClick={onSubmit}
                    testAttr={'login-button'}
                    type="submit"
                    loading={loading}
                    title={'Consent.Agree'}
                />
            </FormWrapper>
        </ViewWrapper>
    );
};

export default SsoTermsView;
